export { default as useProductsAiSearchData } from './useProductsAiSearchData';
